const DayOffType = {
    VACATION: "VACATION",
    SICK_LEAVE: "SICK_LEAVE"
}

export default DayOffType;